import { useSearchParams } from 'react-router-dom';
import { getAvatarConfig } from './avatar-configs';
import { UnifiedAvatarCall } from './UnifiedAvatarCall';

export function AvatarVoiceCall() {
  const [searchParams] = useSearchParams();
  const companyCode = searchParams.get('company') || 'boi';

  // Get company configuration
  let config;
  try {
    config = getAvatarConfig(companyCode);
  } catch (error) {
    // If invalid company, redirect to BOI
    window.location.href = '/avatar?company=boi';
    return null;
  }

  return <UnifiedAvatarCall companyConfig={config} mode="voice" />;
}
